import { ProductType, PriceType } from "@wix/ambassador-forms-v4-form/types";
import { generateUUID } from "@wix/form-schema";
import { getProductPrice } from "../../field-settings/settings-shared/products/product-price.js";
function toProductValue(product, value) {
  const price = Number(value || "0");
  return {
    productId: product.id,
    price: product.priceType === PriceType.DYNAMIC_PRICE ? price : String(price),
    quantity: 1
  };
}
function findProductWithDynamicPrice(products) {
  return products.find(
    (product) => product.priceType === PriceType.DYNAMIC_PRICE
  );
}
function aDynamicPriceProduct() {
  return {
    id: generateUUID(),
    priceType: PriceType.DYNAMIC_PRICE,
    productType: ProductType.DIGITAL,
    quantityLimit: { minimum: 1, maximum: 1 },
    dynamicPriceOptions: { minPrice: "0" }
  };
}
function aFixedPriceProduct(price, id = generateUUID()) {
  return {
    id,
    priceType: PriceType.FIXED_PRICE,
    productType: ProductType.DIGITAL,
    quantityLimit: { minimum: 1, maximum: 1 },
    fixedPriceOptions: { price: String(price) }
  };
}
function excludeProductsWithDynamicPrice(products) {
  return products.filter(
    (product) => product.priceType !== PriceType.DYNAMIC_PRICE
  );
}
function getCustomAmount(productValue, customAmountProduct) {
  return productValue?.productId === customAmountProduct?.id ? String(productValue?.price ?? "") : "";
}
function getProductValueOnCheckboxChange(productId, productValue, productsById) {
  const newValue = productValue?.productId === productId ? void 0 : productId;
  const product = newValue ? productsById[newValue] : void 0;
  return product ? [toProductValue(product, getProductPrice(product))] : [];
}
export {
  aDynamicPriceProduct,
  aFixedPriceProduct,
  excludeProductsWithDynamicPrice,
  findProductWithDynamicPrice,
  getCustomAmount,
  getProductValueOnCheckboxChange,
  toProductValue
};
//# sourceMappingURL=donation-field-utils.js.map
